import { createFileRoute } from "@tanstack/react-router";
import { ForbiddenPage } from "@/features/error/ForbiddenPage";

export const Route = createFileRoute("/403")({
  component: ForbiddenPage,
});
